export const BOILERPLATE_CODE = {
  javascript: `// JavaScript Hello World
console.log("Hello, World!");`,

  python: `# Python Hello World
print("Hello, World!")`,

  java: `// Java Hello World
public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`,

  c: `// C Hello World
#include <stdio.h>

int main() {
    printf("Hello, World!\\n");
    return 0;
}`,

  cpp: `// C++ Hello World
#include <iostream>
using namespace std;
int main() {
    cout << "Hello, World!" << endl;
    return 0;
}`,

  csharp: `// C# Hello World
using System;

class Program {
    static void Main(string[] args) {
        Console.WriteLine("Hello, World!");
    }
}`,

  go: `// Go Hello World
package main

import "fmt"

func main() {
    fmt.Println("Hello, World!")
}`,
}; 